import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import store from '../../../store';


@customElement('light-specsheet')
export class LightSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
		:host {
			font-family: var(--font-family-light);
		}
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;

	}

	render() {
		return html`
		<light-specsheet-page>
			<page-light-summary></page-light-summary>
		</light-specsheet-page>
		<light-specsheet-page>
			<page-light-profile></page-light-profile>
		</light-specsheet-page>
		<light-specsheet-page>
			<page-tables></page-tables>
		</light-specsheet-page>
		<light-specsheet-page>
			<page-tables-second></page-tables-second>
		</light-specsheet-page>

		${when(this.lightProfile.project.luminary === null,
			() => html`
			<light-specsheet-page>
				<page-luminare-all-available></page-luminare-all-available>
			</light-specsheet-page>`,
			() => html`
			<light-specsheet-page>
				<page-luminare></page-luminare>
			</light-specsheet-page>
			<light-specsheet-page>
				<page-diagram-for-light></page-diagram-for-light>
			</light-specsheet-page>
			`
			)}
			`;
		}
	}
